(function () {
  const SCROLL_THRESHOLD = 300;
  const BASE_OFFSET = 130;
  const btn = document.getElementById('scroll-to-top-btn');

  if (!btn) return;

  function getStickyBottomHeight() {
    var selectors = [
      '.shopify-payment-button',
      '.product-form__buttons [style*="position: fixed"]',
      '.cart-notification',
      '.sticky-atc',
      '.sticky-add-to-cart',
      '[class*="sticky-bar"]',
      '[class*="sticky_bar"]',
      '[id*="sticky-bar"]',
      '[id*="sticky_atc"]',
      '.announcement-bar--sticky',
    ];
    var maxHeight = 0;
    selectors.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      var style = window.getComputedStyle(el);
      if (style.position === 'fixed' && style.bottom !== 'auto') {
        var rect = el.getBoundingClientRect();
        var fromBottom = window.innerHeight - rect.bottom;
        if (fromBottom < 10) {
          maxHeight = Math.max(maxHeight, rect.height);
        }
      }
    });
    return maxHeight;
  }

  function updatePosition() {
    var extra = getStickyBottomHeight();
    btn.style.bottom = (BASE_OFFSET + extra + (extra > 0 ? 12 : 0)) + 'px';
  }

  window.addEventListener('scroll', function () {
    btn.classList.toggle('is-visible', window.scrollY >= SCROLL_THRESHOLD);
    updatePosition();
  }, { passive: true });

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  updatePosition();
})();
